import { Tag } from 'antd';

/** Page size theo từng ngữ cảnh — SPEC mục 4.1 */
export const NOTIFICATION_PANEL_PAGE_SIZE = 10; // popup chuông (mục 2.1)
export const NOTIFICATION_LIST_PAGE_SIZE = 20; // trang danh sách đầy đủ
export const NOTIFICATION_WIDGET_LIMIT = 4; // widget trang chủ (mục 2.3)

/** Rút gọn badge > 99 → "99+" — SPEC mục 2.1 / 4.2 */
export const MAX_UNREAD_BADGE = 99;

/**
 * Map nhãn phân loại (`type_label` do BE trả) → style tag.
 * Fallback về style trung tính cho nhãn chưa khai báo.
 */
const TYPE_LABEL_TAG_CLASSNAME: Record<string, string> = {
  'Công việc': 'bg-[#E9F0FF] text-[#4680FF]',
  'Văn bản đến': 'bg-[#FCF1E0] text-[#E58A00]',
  'Văn bản đi': 'bg-[#FFF7E6] text-[#D46B08]',
  'Duyệt lương': 'bg-[#E6F4FF] text-[#1677FF]',
  'Hành chính (Công tác)': 'bg-[#F0F5FF] text-[#2F54EB]',
  'Phiếu phân phát VPP': 'bg-[#F9F0FF] text-[#722ED1]',
  'Lịch cơ quan': 'bg-[#E6FFFB] text-[#08979C]',
  'Nhiệm vụ': 'bg-[#FFF0F6] text-[#C41D7F]',
  'Phát hành văn bản': 'bg-[#F0F5FF] text-[#2F54EB]',
  'Tin nhắn nội bộ': 'bg-[#E6F5F0] text-[#2CA87F]',
  'Lấy ý kiến': 'bg-[#E6F5F0] text-[#2CA87F]',
  'Thông báo chung': 'bg-[#EFF8FE] text-[#1890C1]',
  'Hệ thống': 'bg-[#FFF0F6] text-[#EB2F96]',
};

const DEFAULT_TYPE_LABEL_TAG_CLASSNAME = 'bg-[#F1F5F9] text-[#5B6B79]';

export const renderNotificationTag = (typeLabel?: string) => {
  if (!typeLabel) return null;

  const className =
    TYPE_LABEL_TAG_CLASSNAME[typeLabel] ?? DEFAULT_TYPE_LABEL_TAG_CLASSNAME;

  return (
    <Tag className={`m-0 rounded-[4px] border-0 px-2 py-1 ${className}`}>
      {typeLabel}
    </Tag>
  );
};
